/**
 * Main.js
 *
 * @since 1.0.0
 */

import 'objectFitPolyfill'
import objectFitImages from 'object-fit-images'
import * as Sentry from '@sentry/browser'
import ObserveFontFace from './modules/ObserveFontFace'
import FormValidation from './modules/FormValidation'
import SendForm from './modules/SendForm'
import DependsOn from './modules/DependsOn'
import HeroSlider from './modules/HeroSlider'
import RelevantSlider from './modules/RelevantSlider'
import LazyLoadImage from './modules/LazyLoadImage'
import LazyLoadPicture from './modules/LazyLoadPicture'
import LazyLoadVideo from './modules/LazyLoadVideo'
import Slider from './modules/Slider'
import Toggle from './modules/Toggle'
import ReadMore from './modules/ReadMore'
import Video from './modules/Video'
import StickyHeader from './modules/StickyHeader'
import NavMobile from './modules/NavMobile'
import Maps from './modules/Map'
import NavMobileDropdown from './modules/NavMobileDropdown'
import Counter from './modules/Counter'
import UploadButton from './modules/UploadButton'
import MobileSticky from './modules/MobileSticky'
// import Click from './modules/Click'
;(function IIFE() {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: 'https://fc8c3df33be54dadb019ba5f0912de9b@o36959.ingest.sentry.io/5513890'
    })
  }


  window.addEventListener( "pageshow", function ( event ) {
    

    var historyTraversal = event.persisted || 
                           ( typeof window.performance != "undefined" && 
                                window.performance.navigation.type === 2 );
    if ( historyTraversal ) {
      // Handle page restore.
     // window.location.reload();

     console.log("test reload")
    }
  });


  ObserveFontFace()
  objectFitImages()
  FormValidation()
  SendForm()
  DependsOn()
  HeroSlider()
  RelevantSlider()
  LazyLoadImage()
  Slider()
  LazyLoadPicture()
  LazyLoadVideo()
  Video()
  StickyHeader()
  NavMobile()
  NavMobileDropdown()
  Maps()
  Counter()
  Toggle()
  ReadMore()
  UploadButton()
  MobileSticky()
  // Click()
})()



// WEBPACK FOOTER //
// ./src/js/main.js